var React = require('react');

function CloseMenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.3334 8.54675L23.4534 6.66675L16.0001 14.1201L8.54675 6.66675L6.66675 8.54675L14.1201 16.0001L6.66675 23.4534L8.54675 25.3334L16.0001 17.8801L23.4534 25.3334L25.3334 23.4534L17.8801 16.0001L25.3334 8.54675Z","fill":"#323232"}));
}

CloseMenuInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseMenuInline;

CloseMenuInline.default = CloseMenuInline;
